<ng-template *ngTemplateOutlet='headerTemplate'></ng-template>
@for (segment of hourSegments; track segment) {
  <div class="segment">
    <span class="hour">{{segment}}</span>
    @if (groupedEventsByHour[viewDate | date:"ddMMyy"] && groupedEventsByHour[viewDate | date:"ddMMyy"][segment]) {
      @for (event of groupedEventsByHour[viewDate | date:"ddMMyy"][segment]; track event) {
        <div class="event-container">
          <div class="col trip_data">
            <div class="actual_trip_data">
              <div class="start_time"><mat-icon>access_time</mat-icon> {{event.meta.start_time}}</div>
              <div class="meeting_point">
                <img src="assets/icons/material-icons/filled/md-pin.svg" />
                <span class="display_name">
                  <a [routerLink]='datasetNavigatorService.getDetailRoute("actual_trips", event.meta.actual_trip.id)'>
                    {{event.meta.actual_trip.display_name}}
                  </a>
                </span>
              </div>
            </div>
            <div class="trip_package_title">
              <a [routerLink]='datasetNavigatorService.getDetailRoute("trip_packages", event.package.id)'>
                {{event.package.code}} - {{event.package.description}}
              </a>
            </div>
          </div>
          <div class="col participants_data">
            @if (event.meta.actual_trip.pax_by_resource) {
              <div class="slots" [ngClass]='$safeNavigationMigration(event?.cssClass)'>
                <span>{{event.meta.actual_trip.pax_by_resource.pax_punto_partenza}} / </span>
                @if (event.meta.actual_trip.properties.allotment_blocked_by_trip_resource_id.value) {
                  <span>{{event.meta.actual_trip.pax_by_resource.pax_prenotati_risorsa}} / </span>
                }
                <span>{{event.meta.actual_trip.pax_by_resource.pax_disponibili_risorsa}}</span>
              </div>
            }
            @if (isLoadingParticipants[event.meta.actual_trip.id]) {
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            }
            <div class="participants">
              <div class="first_row">
                <span class="ADT"><b>ADT</b> {{event.meta.participants.adt}}</span>
                <span class="SNR"><b>SNR</b> {{event.meta.participants.snr}}</span>
              </div>
              <div class="second_row">
                <span class="CHD"><b>CHD</b> {{event.meta.participants.chd}}</span>
                <span class="INF"><b>INF</b> {{event.meta.participants.inf}}</span>
              </div>
            </div>
          </div>
          <div class="col resources_data">
            @if (event.meta.actual_trip_guide_languages.length) {
              <div class="guide_languages">
                @for (lang of event.meta.actual_trip_guide_languages; track lang) {
                  <img
                    width="24"
                    class="flag-icon-sidebar"
                    [src]="'assets/images/flags/4x3/' + lang + '.svg'"
                    [alt]="lang"
                    [title]="lang"/>
                }
              </div>
            }
            @if (event.meta.staff_elements && event.meta.staff_elements.length) {
              <div class="trip_resources">
                @for (staffElement of event.meta.staff_elements; track staffElement) {
                  <div class="staff_element">
                    @if (staffElement.entity_staff_element.properties.staff_type.value) {
                      <span class="label">
                        {{staffElement.entity_staff_element.properties.staff_type.value}}:
                      </span>
                    }
                    @if (staffElement.entity_staff_element.entity.description) {
                      <a [routerLink]="datasetNavigatorService.getDetailRoute('entities', staffElement.entity_staff_element.entity_id)"
                        class="description">
                        {{staffElement.entity_staff_element.entity.description}}
                      </a>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
}